<template>
    <div class="modalBackground">
        <div class="ModalForm">
            <div class="header">
                <h1 class="Title">Add New Logo</h1>
                <div class="Options">
                    <button v-on:click.stop="cancel()">Cancel</button>
                </div>
            </div>
            <div class="modalBody" v-if="Saving">
                <p><loading-indicator /> Uploading File...</p>
                <progress v-if="percentComplete !== null" max="100" :value="percentComplete" />
            </div>
            <div class="modalBody" v-if="!Saving">
                <br />
                <label>Upload New Logo: <input type="file" @change="onFileChange" /></label>
            </div>
        </div>
    </div>
</template>

<script>
    import $ from 'jquery';
    export default {
        name: 'AddNewLogoDiaLog',

        data: function () {
            return {
                Saving: false,
                percentComplete: null
            };
        },
        methods: {
            "cancel": function () {
                this.$emit('cancelled', null);
            },
            "onFileChange": function (e) {
                var formData = new FormData();
                var files = e.target.files || e.dataTransfer.files;
                if (!files.length)
                    return;
                var file = files[0];
                formData.append('file', file);

                var thisControl = this;
                this.Saving = true;
                $.ajax({
                    xhr: function () {
                        var xhr = new window.XMLHttpRequest();
                        xhr.upload.addEventListener("progress", function (evt) {
                            if (evt.lengthComputable) {
                                thisControl.percentComplete = (evt.loaded / evt.total) * 100;
                            }
                        }, false);
                        return xhr;
                    },
                    type: 'POST',
                    url: "/Logos",
                    contentType: false,
                    data: formData,
                    processData: false,
                    mimeType: 'multipart/form-data',
                    success: function () {
                        thisControl.Saving = false;
                        thisControl.$emit('logoadded', null);
                    },
                    error: function (xhr) {
                        thisControl.Saving = false;
                        alert("Error saving:" + xhr.responseText);
                    }
                });

            },
        },
    }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->